// Toast compatibility shim: one toaster (Sonner) for the whole app.
// Exposes a `toast` with the react-toastify call surface (success/error/info/
// warn/warning/…) so existing call sites keep working after the swap. Render
// <Toaster/> once (in App.js).
import { toast as sonner } from 'sonner';

const toast = (...args) => sonner(...args);
toast.success = sonner.success;
toast.error = sonner.error;
toast.info = sonner.info;
toast.warning = sonner.warning;
toast.warn = sonner.warning; // react-toastify alias
toast.message = sonner.message;
toast.loading = sonner.loading;
toast.dismiss = sonner.dismiss;
toast.promise = sonner.promise;
toast.custom = sonner.custom;

export { toast };
export default toast;
